import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { TableRowColumn } from '@unite-us/app-components';
import { DynamicTableRowColumnData } from '.';
import ClampedCell from './ClampedCell';
import getColumnStyles from '../styles/getColumnStyles';

const DynamicTableRowColumn = ({
  columnLabel,
  data,
  ...props
}) => {
  const columnData = (
    <DynamicTableRowColumnData
      columnLabel={columnLabel}
      data={data}
      initClick={columnLabel.initClick}
      link={columnLabel.link}
    />
  );

  const isEmpty = _.isFunction(columnLabel.isEmpty) && columnLabel.isEmpty(data);

  return (
    <TableRowColumn
      {...props}
      {...(columnLabel.wrap ? { showOverflow: true } : {})}
      className="dynamic-table__row-column"
      style={getColumnStyles(columnLabel)}
    >
      {
        columnLabel.wrap && !isEmpty ? (
          <ClampedCell maxLines={columnLabel.maxLines}>
            {columnData}
          </ClampedCell>
        ) : columnData
      }
    </TableRowColumn>
  );
};

DynamicTableRowColumn.propTypes = {
  columnLabel: PropTypes.shape({
    initClick: PropTypes.func,
    link: PropTypes.bool,
    wrap: PropTypes.bool,
    isEmpty: PropTypes.func,
    maxLines: PropTypes.number,
  }).isRequired,
  data: PropTypes.object.isRequired,
  style: PropTypes.object,
};

DynamicTableRowColumn.defaultProps = {
  style: {},
};

export default DynamicTableRowColumn;
